import {
  BenefitInvestment,
  ContactCapital,
  DetailInvestment,
  DetailRequirementsInvestment,
  Header,
  MenuItem,
  Message,
  MoreFAQ,
} from 'components/CapitalRevamp';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import styles from './IneligibleInvestment.css';

class IneligibleInvestment extends Component {
  render() {
    return (
      <div>
        <Header />
        <MenuItem
          back
          title="Kembali ke Produk"
          onClick={() => browserHistory.push('/capital')}
        />
        <div className={styles.content}>
          <div className={styles.row}>
            <Message>
              Mohon maaf, saat ini Anda belum memenuhi syarat untuk mengajukan
              pinjaman
            </Message>
            <DetailInvestment />
            <BenefitInvestment />
          </div>
          <div className={styles.line} />
          <div className={styles.row}>
            <DetailRequirementsInvestment />
            <ContactCapital />
            <div className={styles.more} />
            <MoreFAQ
              title="Butuh informasi lebih lanjut mengenai Santara?"
              visitWebsiteUrl="https://www.mokapos.com/invest-id"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default IneligibleInvestment;
